import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _, { lastIndexOf } from 'lodash';
import cx from 'classnames';
import { Frame } from "scenejs";
import Truncate from 'react-truncate';
import { EditorContext } from '../../index';
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { selectWidget, toggleEditMode, updateWidgetProperty, updateWidgetEditorState, deleteWidgets, cloneWidgets, bulkUpdateWidgetOrder, bulkUpdateWidgetLayouts, actionGroup, recalculateSectionColumnWidths, updateWidgetName, arrangeCarouselSlides, toggleHotspotView } from 'actions/editor';
import { Property } from '../../components/properties';
import StoryboardContext from 'components/Storyboard/context';
import { getParentContainerOfType, getWidgetType, isWidgetChildrensHasHotspotChild, isWidgetHasHotspotChild } from 'components/Editor/helper/widget';
import { CAROUSEL_CARD, CONTENT_CARD, GROUP, HOTSPOT, PAGE, SECTION_COLUMN, SLIDE } from 'constants/widgetTypes';
import { CAROUSEL_ARROWS, CAROUSEL_DOTS, CAROUSEL_TRANSITION } from 'constants/carousels';
import { createWidget } from 'actions/editor';
import { isWidgetLocked, useChildrenWidgetSelected, useContainerSelector, usePageWidgetSelector, useSelectedWidgetSelector, useWidgetChildrenSelector } from 'components/Editor/hooks/useEditorSession';

import { Form, Tab, Tabs, Button, OverlayTrigger, Popover } from "react-bootstrap";

import { getBoundingRectFromLayout } from 'components/Editor/helper/layoutManager';
import { Background } from 'components/Editor/components/properties/background';
import { BackgroundView } from '../background';

import styles from './carousel.module.scss';
import { BrandComponentProperty } from 'components/Editor/components/brandElements';
import userRoleService from 'services/userRoles.service';

const state = {
  isFreeSize: false,
  breakPointType: 'desktop'
};

const updateState = (widget) => {
  state.isFreeSize = _.get(widget, 'properties.desktop.free', false);
};
const updateBreakPoint = (breakpoint) => {
  state.breakPointType = breakpoint;
}

const CarouselWidgetView = function CarouselWidget({ className, style, widgetProps, widgetRef, children }) {
  const dispatch = useDispatch();
  const ref = widgetRef;

  const editorContext = React.useContext(EditorContext);
  const editor = editorContext.editorSession.id;

  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');
  const parent = _.get(widgetProps, 'parent');

  const breakpoint = useSelector(state => _.get(state, `${editor}.present.breakpoint`));
  const selectedWidget = useSelector(state => _.get(state, `${editor}.present.selected`));

  const widgetSelected = useSelectedWidgetSelector(editor);
  const container = useContainerSelector(editor, id);

  const editorUIState = _.get(widgetProps, 'editorState');
  const stretched = _.get(widgetProps, 'properties.desktop.stretched', false);
  const freeSize = _.get(widgetProps, 'properties.desktop.free', false);
  const transition = _.get(widgetProps, 'properties.desktop.transition');
  const arrowsProperty = _.get(widgetProps, `properties.${breakpoint}.arrows`);
  const dotsProperty = _.get(widgetProps, `properties.${breakpoint}.dots`);

  const childrenWidgets = useSelector(state => {
    const widgets = _.get(state, `${editor}.present.widgets`);
    return _.filter(widgets, (data) => { return data.parent === id });
  })
  
  const childrenSelection = useChildrenWidgetSelected(editor, id);

  const background = _.get(widgetProps, 'properties.desktop.background');
  const defaultSlide = _.find(children, (child) => {
    return _.get(child, 'props.widgetProps.order') == 1;
  })
  const currentSlide = _.get(widgetProps, 'editorState.currentSlide');

  useEffect(() => {
    if (!_.some(childrenWidgets, { id: currentSlide })) {
      const currentSlide = _.find(childrenWidgets, { order: 1 });
      dispatch(updateWidgetEditorState(editor, id, {
        currentSlide: currentSlide.uid
      }));
    }
  }, [])

  useEffect(()=>{
    if(widgetSelected){
    updateState(widgetSelected[0])
    }

    if(breakpoint){
      updateBreakPoint(breakpoint)
    }
  }, [widgetSelected, breakpoint])

  useEffect(() => {
    if ((_.size(selectedWidget) == 0 || _.size(selectedWidget) > 1) || (_.head(selectedWidget) !== id)) {
      dispatch(updateWidgetEditorState(editor, id, {
        manageSlides: false
      }));
    }
  }, [selectedWidget])

  const carouselCardWidget = currentSlide ? _.find(children, (child) => { return _.get(child, 'props.widgetProps.uid') == currentSlide; }) : defaultSlide;
  const currentSlideOrder = _.get(carouselCardWidget, 'props.widgetProps.order');

  useEffect(() => {
    if (breakpoint == 'mobile') {
      dispatch(updateWidgetEditorState(editor, id, {
        manageSlides: false
      }));
    }
  }, [breakpoint])

  var carouselWidgetStyle = {
    ...style,
    ...getStyles(widgetProps, breakpoint, container)
  }

  var leftnavigationStyles = getNavigationButtonStyles('left', arrowsProperty, 'regular');
  var rightnavigationStyles = getNavigationButtonStyles('right', arrowsProperty, 'regular');

  return (
    <>
      <div
        id={id}
        ref={ref}
        className={cx(className, styles.carouselContainer, 'widget', {
          [styles.stretched]: stretched && !freeSize,
          [styles.mobile]: breakpoint === 'mobile',
          [styles.partialSelection]: childrenSelection.selected,
        })}
        style={carouselWidgetStyle}
        data-widget-id={id}
        data-widget-type={type}
        data-selectable={true}
      >
        <BackgroundView background={background} />
        {carouselCardWidget &&
          (currentSlide || defaultSlide) && React.cloneElement(carouselCardWidget, {})
        }
        {_.get(arrowsProperty, 'enabled') &&
          <>
            {(_.get(transition, 'autoPlay') || currentSlideOrder !== 1) &&
              <Button variant='info' style={leftnavigationStyles} className={styles.navigationButton}>
                {renderArrowIcons(_.get(arrowsProperty, 'style'), 'left', arrowsProperty)}
              </Button>
            }
            {(_.get(transition, 'autoPlay') || currentSlideOrder !== _.size(children)) &&
              <Button variant='info' style={rightnavigationStyles} className={styles.navigationButton}>
                {renderArrowIcons(_.get(arrowsProperty, 'style'), 'right', arrowsProperty)}
              </Button>
            }
          </>
        }
        {_.get(dotsProperty, 'flag') &&
          <div style={{ bottom: `${_.get(dotsProperty, 'offset')}px` }} className={styles.paginationRowContainer}>
            {
              _.map(_.orderBy(childrenWidgets, ['order'], ['asc']), (data, index) => {
                var isActive = _.get(data, 'uid') == currentSlide;
                var lastIndex = _.size(childrenWidgets) - 1
                return renderDotsIcons(dotsProperty, index, isActive, lastIndex)
              })
            }
          </div>
        }
      </div>

      {_.get(editorUIState, 'manageSlides') &&
        <ManageSlidesDialog
          id={id}
          parent={id}
          topParent={parent}
          editor={editor}
          widget={widgetProps}
          children={children}
          childrenWidgets={childrenWidgets}
          onCancel={() => {
            dispatch(updateWidgetEditorState(editor, id, {
              manageSlides: false
            }));
          }}
        />
      }
    </>
  );
};

const CarouselWidgetDesktopAction = (props) => {
  const dispatch = useDispatch();
  const [view, setView] = useState(null);

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;

  const storyboardContext = React.useContext(StoryboardContext);

  const storyboardType = _.get(storyboardContext, 'type');
  const id = _.get(props, 'uid');
  const type = _.get(props, 'type');
  const parent = _.get(props, 'parent');
  const container = useContainerSelector(editorSession, id);
  const breakpoint = useSelector(state => _.get(state, `${editorSession}.present.breakpoint`));
  const childrenWidgets = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`);
    return _.filter(widgets, (data) => { return data.parent === id });
  })
  const currentSlide = _.get(props, 'editorState.currentSlide');
  const currentSlideWidget = Array.isArray(childrenWidgets) 
  ? childrenWidgets.find(widget => widget?.uid === currentSlide) 
  : null;
  const isCurrentSlideLocked = _.get(currentSlideWidget, `properties.${breakpoint}.locked`);

  const background = getCarouselBackground(childrenWidgets, currentSlide);

  const editMode = useSelector(state => {
    return _.get(state, `${editorSession}.present.editMode`) === id
  });
  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const brandkitEnabled = _.get(workspace, 'brandkitEnabled', false);
  const allowBrandkit = useSelector((state) =>
    _.get(state, `${editorSession}.present.entityType`)) !== 'PALETTE_COMPONENT';

  useEffect(() => {
    if (!currentSlide) {
      handleSlideChange(1)
    }
  }, [])

  useEffect(() => {
    setView(null);
  },[id])

  const changeView = (view) => {
    dispatch(toggleEditMode(editorSession, props.uid, false));
    setView(view);

    dispatch(updateWidgetEditorState(editorSession, id, {
      manageSlides: false
    }));
  }

  const closePopup = () => {
    dispatch(toggleEditMode(editorSession, props.uid, false));
    setView(null);
  }

  const handleManageSlides = () => {
    dispatch(toggleEditMode(editorSession, props.uid, true));
    setView(null);

    dispatch(updateWidgetEditorState(editorSession, id, {
      manageSlides: true
    }));
  }

  const handleSlideChange = (curentIndex) => {
    const currentSlide = _.find(childrenWidgets, { order: curentIndex });
    dispatch(updateWidgetEditorState(editorSession, id, {
      currentSlide: currentSlide.uid
    }));
  }

  return (
    <>
      <Property.SlideChanger slides={childrenWidgets} parent={id} currentSlideId={currentSlide} onChange={handleSlideChange} editorSession={editorSession} type={type} topParent={parent} />
      <Property.Divider />
      <Property.Action className={styles.textButton} onClick={handleManageSlides}>
        Manage Slides
      </Property.Action>
      <Property.Divider />
      {!isCurrentSlideLocked &&
        <Property.Action className={styles.textButton} onClick={() => changeView('background')}>
          Change Background
        </Property.Action>
      }
      {!isCurrentSlideLocked && <Property.Divider />}
      <Property.Action className={styles.iconButton} tooltip="Settings" onClick={() => changeView('settings')}>
        <i className={cx("cleverstory-settings", styles.settingsIcon)} />
      </Property.Action>
      <Property.Action className={styles.iconButton} tooltip="Arrows and Dots" onClick={() => changeView('style')}>
        <i className={cx("cleverstory-customize", styles.customizeIcon)} />
      </Property.Action>
      {(_.get(container, 'type') === PAGE || _.get(container, 'type') === SLIDE) &&
        <Property.Action className={styles.iconButton} tooltip='Stretch' onClick={() => changeView('stretch')}>
          <i className={cx("cleverstory-stretch")} />
        </Property.Action>
      }
      {brandkitEnabled && allowBrandkit && userRoleService.canManageUsers() &&
        <Property.Action className={styles.iconButton} tooltip='Add to Brand Kit' onClick={() => changeView('brandMedia')}>
          <i className={'cleverstory-brandmedia'} />
        </Property.Action>
      }

      {!editMode && view === 'background' &&
        <Background.Dialog id={id}
          value={background}
          onChange={(value) => {
            dispatch(updateWidgetProperty(editorSession, currentSlide, 'desktop', {
              background: value
            }));
          }}
          onCancel={() => {
            closePopup();
          }}
        />
      }

      {!editMode && view === 'settings' &&
        <CarouselSettingsEditor
          id={id}
          editor={editorSession}
          widget={props}
          onCancel={() => {
            closePopup()
          }}
        />
      }

      {!editMode && view === 'style' &&
        <CarouselStyleEditor
          id={id}
          editor={editorSession}
          widget={props}
          onCancel={() => {
            closePopup()
          }}
        />
      }

      {!editMode && view === 'stretch' &&
        <StretchCarouselDialog
          id={id}
          editor={editorSession}
          widget={props}
          onCancel={() => {
            closePopup()
          }}
          storyboardType={storyboardType}
        />
      }

      {view === 'brandMedia' &&
        <BrandComponentProperty type={'CAROUSELS'} widgets={[props]} onCancel={() => closePopup()} />
      }

    </>
  );
}

const CarouselWidgetMobileAction = (props) => {
  const dispatch = useDispatch();

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;
  const parent = _.get(props, 'parent');
  const [view, setView] = useState(null);
  const breakpoint = useSelector(state => _.get(state, `${editorSession}.present.breakpoint`));
  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const brandkitEnabled = _.get(workspace, 'brandkitEnabled', false);
  const allowBrandkit = useSelector((state) =>
    _.get(state, `${editorSession}.present.entityType`)) !== 'PALETTE_COMPONENT';

  const id = _.get(props, 'uid');
  const type = _.get(props, 'type');
  const currentSlide = _.get(props, 'editorState.currentSlide');
  const childrenWidgets = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`);
    return _.filter(widgets, (data) => { return data.parent === id });
  })

  const changeView = (view) => {
    setView(view);
  }

  const closePopup = () => {
    setView(null);
  }

  const handleSlideChange = (curentIndex) => {
    const currentSlide = _.find(childrenWidgets, { order: curentIndex });
    dispatch(updateWidgetEditorState(editorSession, id, {
      currentSlide: currentSlide.uid
    }));
  }

  return (
    <>
      <Property.SlideChanger slides={childrenWidgets} parent={id} currentSlideId={currentSlide} onChange={handleSlideChange} editorSession={editorSession} type={type} topParent={parent}/>
      <Property.Divider />
      <Property.Action className={styles.iconButton} tooltip='Arrows and Dots' onClick={() => changeView('design')}>
        <i className={cx("cleverstory-customize")} />
      </Property.Action>
      {brandkitEnabled && allowBrandkit && userRoleService.canManageUsers() &&
        <Property.Action className={styles.iconButton} tooltip='Add to Brand Kit' onClick={() => changeView('brandMedia')}>
          <i className={'cleverstory-brandmedia'} />
        </Property.Action>
      }
      
      {view === 'design' &&
        <CarouselStyleEditor
          id={id}
          editor={editorSession}
          widget={props}
          onCancel={() => {
            closePopup()
          }}
        />
      }
      {view === 'brandMedia' &&
        <BrandComponentProperty type={'CAROUSELS'} widgets={[props]} onCancel={() => closePopup()} />
      }
    </>
  );
}

const CarouselStyleEditor = ({ id, widget, position, ...rest }) => {
  const dispatch = useDispatch();

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;
  const breakpoint = useSelector(state => _.get(state, `${editorSession}.present.breakpoint`));
  const properties = _.get(widget, `properties.${breakpoint}`, {});
  const arrowProperty = _.get(properties, `arrows`, {}) || {};
  const dotsProperty = _.get(properties, `dots`, {}) || {};

  const [state, setState] = useState({
    activeTab: 'regular'
  })

  const handleTabChange = (key) => {
    setState(() => {
      return {
        ...state,
        activeTab: key
      }
    })
  }

  const handleArrowPropertyChange = (field, value) => {
    dispatch(updateWidgetProperty(editorSession, widget.uid, breakpoint, {
      arrows: {
        ...arrowProperty,
        [field]: value
      }
    }));
  }

  const handleArrowColorChange = React.useCallback((color) => {
    var request = {
      ...arrowProperty[state.activeTab],
      color: color
    }

    handleArrowPropertyChange(state.activeTab, request);
  }, [properties, state.activeTab]);

  const handleArrowBackgroundColorChange = React.useCallback((color) => {
    var request = {
      ...arrowProperty[state.activeTab],
      backgroundColor: color
    }

    handleArrowPropertyChange(state.activeTab, request);
  }, [properties, state.activeTab]);

  const handleDotsPropertyChange = (field, value) => {
    dispatch(updateWidgetProperty(editorSession, widget.uid, breakpoint, {
      dots: {
        ...dotsProperty,
        [field]: value
      }
    }));
  }

  return (
    <Property.Dialog className={styles.styleDialog}
      width={250}
      target={`#${id}`}
      title={'Arrows & Dots'}
      onCancel={rest.onCancel}
    >
      <Property.Body className={styles.container}>
        <Property className={styles.arrowSettings}>
          <Property.Switch
            id="arrows"
            title={'Arrows'}
            className={cx(styles.enableSwitch, { [styles.activated]: arrowProperty.enabled })}
            value={arrowProperty.enabled}
            onChange={() => handleArrowPropertyChange('enabled', !arrowProperty.enabled)}
          />
          {arrowProperty.enabled &&
            <>
              <Property name="Arrow Styles" className={styles.arrowStyles}>
                <div className={styles.buttonConatiner}>
                  {CAROUSEL_ARROWS.map((data, index) => {
                    return (
                      <div key={index} onClick={() => { handleArrowPropertyChange('style', data.type) }} className={cx(styles.arrowButton, { [styles.active]: data.type === _.get(arrowProperty, 'style') })}>
                        {renderArrowIcons(data.type, 'left')}
                        {renderArrowIcons(data.type, 'right')}
                      </div>
                    )
                  })
                  }
                </div>
              </Property>
              <Property name="Arrow Size" className={styles.arrowSize}>
                <Property.Slider
                  input
                  min={8}
                  max={72}
                  step={1}
                  value={_.get(arrowProperty, 'size')}
                  onChange={(value) => { handleArrowPropertyChange('size', value) }}
                />
              </Property>
              <Property name="Offset" className={styles.arrowOffset}>
                <Property.Slider
                  input
                  min={0}
                  max={72}
                  step={1}
                  value={_.get(arrowProperty, 'offset')}
                  onChange={(value) => { handleArrowPropertyChange('offset', value) }}
                />
              </Property>
              <Property name="Background Corner Radius" className={styles.arrowRadius}>
                <Property.Slider
                  input
                  min={0}
                  max={50}
                  step={1}
                  value={_.get(arrowProperty, 'backgroundCornerRadius')}
                  onChange={(value) => { handleArrowPropertyChange('backgroundCornerRadius', value) }}
                />
              </Property>
            </>
          }
        </Property>
        {arrowProperty.enabled &&
          <Property className={styles.buttonDesignProperty}>
            <Tabs
              activeKey={state.activeTab}
              onSelect={handleTabChange}
              className={styles.buttonStyleTabs}>
              <Tab eventKey="regular" title="Regular" className={styles.buttonStyleTab}>
                <Property.Color title={'Arrow Colour'} value={_.get(arrowProperty, 'regular.color')} onChange={(color) => handleArrowColorChange(color, 'regular')} />
                <Property.Color title={'Background Colour'} clearable={true} value={_.get(arrowProperty, 'regular.backgroundColor')} onChange={handleArrowBackgroundColorChange} />
              </Tab>
              <Tab eventKey="hover" title="Hover" className={styles.buttonStyleTab}>
                <Property.Color title={'Arrow Colour'} value={_.get(arrowProperty, 'hover.color')} onChange={handleArrowColorChange} />
                <Property.Color title={'Background Colour'} clearable={true} value={_.get(arrowProperty, 'hover.backgroundColor')} onChange={handleArrowBackgroundColorChange} />
              </Tab>
            </Tabs>
          </Property>
        }
        <Property className={styles.dotSettings}>
          <Property.Switch
            id="dots"
            title={'Pagination Dots'}
            value={dotsProperty.flag}
            className={cx(styles.enableSwitch, { [styles.activated]: dotsProperty.flag })}
            onChange={() => handleDotsPropertyChange('flag', !dotsProperty.flag)}
          />
          {dotsProperty.flag &&
            <>
              <Property name="Dots Styles" className={styles.dotsStyles}>
                <div className={styles.buttonConatiner}>
                  {CAROUSEL_DOTS.map((data, index) => {
                    return (
                      <div key={index} onClick={() => { handleDotsPropertyChange('style', data.type) }} className={cx(styles.arrowButton, { [styles.active]: data.type === _.get(dotsProperty, 'style') })}>
                        {_.times(3, (dotIndex) => {
                          return renderDotsIcons(data, dotIndex)
                        })}
                      </div>
                    )
                  })
                  }
                </div>
              </Property>
              <Property.Color className={styles.colorProperty} title={'Default Colour'} value={_.get(dotsProperty, 'defaultColor')} onChange={(color) => { handleDotsPropertyChange('defaultColor', color) }} />
              <Property.Color className={styles.colorProperty} title={'Selected Colour'} value={_.get(dotsProperty, 'selectedColor')} onChange={(color) => { handleDotsPropertyChange('selectedColor', color) }} />
              <Property name="Dots Size" className={styles.dotsSize}>
                <Property.Slider
                  input
                  min={8}
                  max={24}
                  step={1}
                  value={_.get(dotsProperty, 'size')}
                  onChange={(value) => { handleDotsPropertyChange('size', value) }}
                />
              </Property>
              <Property name="Space Between Dots" className={styles.dotsSpace}>
                <Property.Slider
                  input
                  min={5}
                  max={30}
                  step={1}
                  value={_.get(dotsProperty, 'cornerRadius', 4)}
                  onChange={(value) => { handleDotsPropertyChange('cornerRadius', value) }}
                />
              </Property>
              <Property name="Offset" className={styles.dotsOffset}>
                <Property.Slider
                  input
                  min={0}
                  max={72}
                  step={1}
                  value={_.get(dotsProperty, 'offset')}
                  onChange={(value) => { handleDotsPropertyChange('offset', value) }}
                />
              </Property>
            </>
          }
        </Property>
      </Property.Body>
    </Property.Dialog>
  )
}

const CarouselSettingsEditor = ({ id, widget, position, ...rest }) => {
  const dispatch = useDispatch();

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;
  const breakpoint = useSelector(state => _.get(state, `${editorSession}.present.breakpoint`));
  const transition = _.get(widget, `properties.${breakpoint}.transition`, {}) || {};

  const handlePropertyChange = (field, value) => {
    dispatch(updateWidgetProperty(editorSession, widget.uid, breakpoint, {
      transition: {
        ...transition,
        [field]: value
      }
    }));
  }

  return (
    <Property.Dialog className={styles.settingsDialog}
      width={250}
      target={`#${id}`}
      title={'Transition Settings'}
      onCancel={rest.onCancel}
    >
      <Property.Body className={styles.dialogBody}>
        <Property className={styles.autoPlaySettings}>
          <Property.Switch
            id="autoPlay"
            title={'Autoplay & Loop'}
            value={transition.autoPlay}
            onChange={() => handlePropertyChange('autoPlay', !transition.autoPlay)}
          />
          {transition.autoPlay &&
            <div className={styles.configurations}>
              <Property name="Slide Visible Duration" className={styles.durationProperty}>
                <Property.Slider
                  input
                  min={1}
                  max={5}
                  step={1}
                  value={_.get(transition, 'visibleDuration')}
                  onChange={(value) => { handlePropertyChange('visibleDuration', value) }}
                />
              </Property>
              <Property.Switch
                id="pauseOnHover"
                title={'Pause On Hover'}
                value={transition.pauseOnHover}
                onChange={() => handlePropertyChange('pauseOnHover', !transition.pauseOnHover)}
              />
            </div>
          }
        </Property>
        <Property name="Transition Effects" nameStyle={styles.propertyName} className={styles.transitionEffectsSettings}>
          <Property name="Transition Speed" className={styles.transtionSpeedProperty}>
            <Property.Slider
              input
              min={1}
              max={5}
              step={1}
              value={_.get(transition, 'speed')}
              onChange={(value) => { handlePropertyChange('speed', value) }}
            />
          </Property>
          <div className={styles.animationContainer}>
            <div className={styles.grid}>
              {
                CAROUSEL_TRANSITION.map((item, index) => {
                  const active = _.get(transition, 'style') === item.type;
                  return (
                    <div key={index}
                      className={cx(styles.transitionTypeButton, {
                        [styles.active]: active
                      })}
                      onClick={() => handlePropertyChange('style', item.type)}
                    >
                      <div className={styles.icon}>
                        <img src={item.buttonImg} />
                      </div>
                      <span>{item.name}</span>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </Property>
      </Property.Body>
    </Property.Dialog>
  )
}

/**
 * Manage Slides Dialog
 * 
*/
const ManageSlidesDialog = ({ id, parent, widget, children, childrenWidgets, position, topParent, ...rest }) => {
  const dispatch = useDispatch();

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;
  const parentType = getWidgetType(editorSession, topParent);
  let currentSlide = _.get(widget, 'editorState.currentSlide');
  currentSlide = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return widgets.find(item => item.uid === currentSlide);
  });
  const handleAddSlides = () => {
    const defaultChild = _.head(children);
    let newSlideProperties = _.get(defaultChild, 'props.widgetProps.properties');
    newSlideProperties = {
      ...newSlideProperties,
      "desktop": {
        ...newSlideProperties.desktop,
        "locked": false,
        "background": {
          "type": "color",
          "color": {
            "type": "solid",
            "r": 0,
            "g": 0,
            "b": 0,
            "a": 1
          },
          "media": null,
          "opacity": 0,
          "scale": null,
          "position": null
        },
        "container": {
          "minWidth": 1200 * 100 / 100,
          "alignment": "center"
        },
      },
      "mobile": {
        ...newSlideProperties.mobile,
        "locked": false 
      }
    }

    if (_.size(childrenWidgets) == 50) {
      return;
    }

    actionGroup.start();
    dispatch(createWidget(
      editorSession,
      [
        {
          type: CAROUSEL_CARD,
          name: `Slide`,
          properties: newSlideProperties
        },
      ],
      parent
    ))
    if (parentType !== HOTSPOT){
      dispatch(toggleHotspotView(editorSession, null)); 
    }
    dispatch(selectWidget(editorSession, [parent])) 
    actionGroup.end();
  }

  return (
    <Property.Dialog className={styles.manageSlidesDialog}
      width={250}
      target={`#${id}`}
      title={'Manage Slides'}
      onCancel={rest.onCancel}
    >
      <Property.Body>
        <Property className={styles.listView}>
          <SliderView parent={id} currentSlide={currentSlide} slides={_.orderBy(childrenWidgets, ['order'], ['asc'])} editorSession={editorSession} topParent={topParent}/>
        </Property>
        <Property className={styles.actionContainer}>
          <Button variant='primary' onClick={handleAddSlides}>
            <i className={cx('cleverstory-plus', styles.plusIcon)} />
            Add New Slide
          </Button>
        </Property>
      </Property.Body>
    </Property.Dialog>
  )
}

const SliderView = ({ slides, parent, currentSlide, editorSession, topParent }) => {
  const dispatch = useDispatch();
  const parentType = getWidgetType(editorSession, topParent);

  const handleMove = (dragIndex, hoverIndex) => {
    const dragWidget = _.find(slides, { order: (dragIndex + 1) });
    const hoverWidget = _.find(slides, { order: (hoverIndex + 1) });
    if (parentType !== HOTSPOT){
      dispatch(toggleHotspotView(editorSession, null));
    }
    dispatch(arrangeCarouselSlides(editorSession, dragWidget, hoverIndex));

    if (_.isEqual(currentSlide, dragWidget)) {
      changeCurrentSlide(hoverWidget)
    }

    if (_.isEqual(currentSlide, hoverWidget)) {
      changeCurrentSlide(dragWidget)
    }
  }

  const changeCurrentSlide = (slide) => {
    if (slide) {
      dispatch(updateWidgetEditorState(editorSession, parent, {
        currentSlide: slide.uid
      }));
    }
  }

  const onDelete = (id) => {

    if (id == _.get(currentSlide, 'uid', null)) {
      const deleteWidget = _.find(slides, { 'uid': id });
      const order = _.get(deleteWidget, 'order') == _.size(slides) ? (_.get(deleteWidget, 'order') - 1) : (_.get(deleteWidget, 'order') + 1)
      const newCurrentSlide = _.find(slides, { 'order': order })
      dispatch(updateWidgetEditorState(editorSession, parent, {
        currentSlide: newCurrentSlide.uid
      }));
    }
  }

  return (
      <div className={styles.sortableSlidesList}>
        {slides && _.map(slides, (slide, index) => {
          return (
            <SliderItem id={slide.uid} sliderData={slide}
              moveSlide={handleMove}
              slides={slides}
              currentSlide={currentSlide}
              parent={parent}
              topParent={topParent}
              index={index}
              onDelete={onDelete}
              editorSession={editorSession} />
          )
        })
        }
      </div>
  )
}

const SliderItem = ({ id, sliderData, slides, parent, currentSlide, onDelete, moveSlide, index, editorSession, topParent }) => {
  const dispatch = useDispatch();
  const ref = React.useRef(null);
  const inputRef = React.useRef(null);
  const prevStateRef = React.useRef(slides);
  const [editable, setEditable] = useState(false);
  const [inputName, setInputName] = useState(_.get(sliderData, 'name'));
  const parentType = getWidgetType(editorSession, topParent);
  const breakpoint = useSelector(state => _.get(state, `${editorSession}.present.breakpoint`));
  const allWidgets = useSelector(state => _.get(state, `${editorSession}.present.widgets`)) || [];

  const isSlideLocked = isWidgetLocked(allWidgets, sliderData, breakpoint)

  const [{ handlerId }, drop] = useDrop({
    accept: 'SLIDE',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      }
    },
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      // Time to actually perform the action
      moveSlide(dragIndex, hoverIndex)
      item.index = hoverIndex
    },
  });

  const [{ isDragging }, drag, preview] = useDrag({
    type: 'SLIDE',
    item: () => {
      return { id, index }
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });

  useEffect(() => {
    const hasIncreased = slides.length > prevStateRef.current.length;
    const newSlide = _.find(slides, function (data) { return data.order == _.size(slides); })

    if (hasIncreased && newSlide?.uid && !_.isEqual(currentSlide.uid, newSlide.uid)) {
      dispatch(updateWidgetEditorState(editorSession, parent, {
        currentSlide: newSlide.uid
      }));
    }
    prevStateRef.current = slides;
  }, [slides])

  const handleClone = () => {
    if (sliderData) {
      if (parentType !== HOTSPOT){
        dispatch(toggleHotspotView(editorSession, null));
      }
      dispatch(cloneWidgets(editorSession, _.get(sliderData, "parent"), [_.get(sliderData, "uid")]))
    }
  }

  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  useEffect(() => {
    if (editable) {
      inputRef.current.focus();
    }
  }, [editable]);

  const popover = (
    <Popover key={sliderData.id} bsPrefix="popover" className={styles.carouselSettingsPopover}>
      <Popover.Body className={styles.carouselSettingsPopoverBody}>
        <div className={styles.carouselSettingsPopoverContent}>
          {!isSlideLocked && <span onClick={() => { setEditable(true) }}>Rename</span>}
          {_.size(slides) < 50 &&
            <span onClick={handleClone}>Duplicate</span>
          }
          {(_.size(slides) !== 1 && !isSlideLocked) &&
            <span onClick={() => { handleDelete(sliderData.uid) }} >Delete</span>
          }
        </div>
      </Popover.Body>
    </Popover>
  );

  const handleDelete = (widget) => {
    if (widget) {
      onDelete(widget);
      dispatch(deleteWidgets(editorSession, [widget]))
    }
  }

  const handleNameChange = (e) => {
    setInputName(e.target.value);
  }

  const updateSlideName = (uid) => {
    dispatch(updateWidgetName(editorSession, uid, inputName))
    setEditable(false);
  }

  return (
    <div ref={ref} key={index} className={styles.itemWrapper} style={{ opacity }} data-handler-id={handlerId}>
      <div ref={preview} className={cx(styles.sliderItem)}>
        <div className={styles.info}>
          <i className={cx('cleverstory-drag', styles.iconDrag)} />
          {editable &&
            <input
              ref={inputRef}
              type={'text'}
              className={styles.name}
              value={inputName}
              onChange={handleNameChange}
              onBlur={() => updateSlideName(sliderData.uid)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  updateSlideName(sliderData.uid);
                }
              }}
            />
          }

          {!editable &&
            <span className={styles.name}>
              <Truncate lines={1}>{_.get(sliderData, 'name')}</Truncate>
            </span>
          }
        </div>
        {!( _.size(slides) >= 50 && isSlideLocked ) && (
          <OverlayTrigger
            rootClose={true}
            rootCloseEvent="mousedown"
            key={sliderData.id}
            trigger="click"
            placement="right"
            overlay={popover}
          >
            <i className={cx('cleverstory-more', styles.iconMore)} />
          </OverlayTrigger>
        )}
      </div>
    </div>
  )
}

export const StretchCarouselDialog = ({ id, widget, position, ...rest }) => {
  const dispatch = useDispatch();

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;

  const breakpoint = useSelector(state => _.get(state, `${editorSession}.present.breakpoint`));
  const properties = _.get(widget, `properties.desktop`, {});
  const padding = _.get(properties, 'padding', 0);
  const stretched = _.get(properties, 'stretched', false);
  const freeSize = _.get(properties, 'free', false);
  const layout = _.get(widget, `properties.${breakpoint}.layout`);

  const pageWidget = usePageWidgetSelector(editorSession, widget.uid);
  const pageWidth = _.get(pageWidget, 'properties.desktop.container.minWidth', 1200);

  const handlePropertyChange = (value) => {
    dispatch(updateWidgetProperty(editorSession, widget.uid, 'desktop', value));
  }

  const handleSectionSize = (stretched) => {
    var frame = new Frame(layout);
    const rect = getBoundingRectFromLayout(layout);

    if (stretched) {
      frame.remove('width');
      frame.set('transform', 'translate', `0px, ${rect.y}px`);
    } else {
      frame.set('width', `${pageWidth}px`);
      frame.set('transform', 'translate', `0px, ${rect.y}px`);
    }

    handlePropertyChange({
      stretched: stretched,
      free: false,
      layout: frame.get()
    });
  }

  const selectFreeSize = () => {
    var frame = new Frame(layout);
    const rect = getBoundingRectFromLayout(layout);

    frame.set('transform', 'translate', `${rect.x}px, ${rect.y}px`);
    frame.set('width', `${pageWidth}px`);

    handlePropertyChange({
      free: !freeSize,
      stretched: false,
      layout: frame.get()
    });
  }

  return (
    <Property.Dialog className={styles.stretchCarouselDialog}
      width={230}
      target={`#${id}`}
      title={'Stretch Carousel'}
      onCancel={rest.onCancel}
    >
      <Property.Body>
        <Property className={styles.carouselSizeProperty}>
          <div className={styles.carouselSizeContainer}>
          {((rest.storyboardType !== 'INTERACTIVE_CONTENT') && (rest.storyboardType !== 'SPATIAL')) &&
              <div className={cx(styles.carouselSize, styles.stretched, {
              [styles.active]: stretched && !freeSize
            })} onClick={() => handleSectionSize(true)}>
              <div className={styles.icon}>
                <div className={styles.inner}></div>
              </div>
              <label>Screen</label>
              </div>
            }
            <div className={cx(styles.carouselSize, {
              [styles.active]: !stretched && !freeSize
            })} onClick={() => handleSectionSize(false)}>
              <div className={styles.icon}>
                <div className={styles.inner}></div>
              </div>
              <label>Page</label>
            </div>
            <div className={cx(styles.carouselSize, styles.free, {
              [styles.active]: freeSize
            })} onClick={selectFreeSize}>
              <div className={styles.icon}>
                <div className={styles.inner}>
                  <div className={styles.pointer1} />
                  <div className={styles.pointer2} />
                  <div className={styles.pointer3} />
                  <div className={styles.pointer4} />
                </div>
              </div>
              <label>Free</label>
            </div>
          </div>
        </Property>
      </Property.Body>
    </Property.Dialog>
  );
}

const renderArrowIcons = (type, direction, properties = null) => {

  var arrowIconStyles = getArrowStyles(properties);
  switch (type) {
    case 'MORDERN':
      return (
        <i style={arrowIconStyles} className={cx({ ['cleverstory-drop-down-left']: direction == 'left' }, { ['cleverstory-drop-down-right']: direction == 'right' })}></i>
      )

    case 'STANDARD':
      return (
        <i style={arrowIconStyles} className={cx({ ['cleverstory-left']: direction == 'left' }, { ['cleverstory-right']: direction == 'right' })}></i>
      )

    case 'DEFAULT':
      return (
        <i style={arrowIconStyles} className={cx({ ['cleverstory-fill-left']: direction == 'left' }, { ['cleverstory-fill-right']: direction == 'right' })}></i>
      )

    default:
      return (
        <i style={arrowIconStyles} className={cx({ ['cleverstory-left']: direction == 'left' }, { ['cleverstory-right']: direction == 'right' })}></i>
      )
  }
}

const renderDotsIcons = (data, index, isActive, lastIndex) => {
  const lastPagination = lastIndex == index;

  const dotStyles = _.get(data, 'flag') ? getPaginationStyles(data, isActive, lastPagination) : {}

  var type = _.get(data, 'style') || _.get(data, 'type')
  switch (type) {

    case 'DEFAULT':
      return (
        <i key={index} style={dotStyles} className={cx('cleverstory-pagination-default', styles.paginationIcon)} />
      )

    case 'STANDARD':
      return (
        <i key={index} style={dotStyles} className={cx('cleverstory-pagination-standard', styles.paginationIcon)} />
      )

    default:
      return (
        <i key={index} style={dotStyles} className={cx('cleverstory-pagination-standard', styles.paginationIcon)} />
      )
  }
}

const CarouselWidget = React.forwardRef((props, ref) => {
  return <CarouselWidgetView {...props} ref={ref} />
});


CarouselWidget.actions = (editorSession, breakpoint, props) => {
  return (
    <>
      {breakpoint === 'desktop' &&
        <CarouselWidgetDesktopAction editorSession={editorSession} breakpoint={breakpoint} {...props} />
      }
      {breakpoint === 'mobile' &&
        <CarouselWidgetMobileAction editorSession={editorSession} breakpoint={breakpoint} {...props} />
      }
    </>
  );
}

CarouselWidget.processRequest = (widget) => {
  var updated = _.omit(widget, 'editorState');
  var background = _.get(widget, 'properties.desktop.background');

  if (!background) {
    return updated;
  }

  var media = _.get(background, 'media.id');
  if (media) {
    background = {
      ...background,
      media: media
    }
  }

  return {
    ...updated,
    properties: {
      ...updated.properties,
      desktop: {
        ...updated.properties.desktop,
        background: background
      }
    }
  }
}

CarouselWidget.moveableConfig = (editorSession, widgetProps, breakpoint) => {
  const { isFreeSize, breakPointType } = state;
  const desktop = breakpoint === 'desktop';
  const freeSize = _.get(widgetProps, 'properties.desktop.free', false);

  return {
    draggable: true,
    resizable: true,
    rotatable: false,
    cloneable: true,
    deletable: true,
    onDrag: (layout) => {
      const frame = new Frame(layout);
      const freeSize = _.get(widgetProps, 'properties.desktop.free', false);
      const translate = frame.get("transform", "translate");
      const values = _.split(translate, ",");
      const element = document.querySelector('[data-storyboard-type]');
      const storyboardType = element?.getAttribute('data-storyboard-type');
      
      var x = parseInt(values[0]);
      var y = parseInt(values[1]);

      if (['INTERACTIVE_CONTENT', 'SPATIAL'].includes(storyboardType) && (!isFreeSize && breakPointType === 'mobile')){
        y = Math.max(0, y);
      }

      const newTranslate = `${isFreeSize && breakPointType === 'desktop' ? x : 0}px, ${y}px`;

      frame.set("transform", "translate", newTranslate);
      return frame.get();
    },
    renderDirections: ((breakpoint == 'mobile') || (desktop && !freeSize)) ? ['n', 's'] : (desktop && freeSize) ? ["n", "s", "ne", "nw", "se", "sw", "e", "w"] : [],
    onResize: (widget, layout, breakpoint) => {
      const stretched = _.get(widget, 'properties.desktop.stretched');
      const freeSize = _.get(widget, 'properties.desktop.free', false);

      const frame = new Frame(layout);
      if (stretched && !freeSize && breakpoint === 'desktop') {

        const margin = _.get(widget, 'properties.desktop.margin', 0);
        const width = `calc(var(--editor-width) - 2 * ${margin}px)`;
        frame.set('width', width);
      }

      if (isFreeSize && breakPointType === 'mobile'){
        frame.set('width', '100%');
      }

      return frame.get();
    },
    onReparent: (widget, parent) => {
      const parentType = getWidgetType(editorSession, parent);
      if (parentType === PAGE) return true;
      if (!isFreeSize) return false;

      const [hasHotspotChild, childrenHasHotspot] = [
        isWidgetHasHotspotChild(editorSession, widget),
        isWidgetChildrensHasHotspotChild(editorSession, widget)
      ];
      const parentWidget = getParentContainerOfType(editorSession, widget, CONTENT_CARD);
      const denyHotspotReparent = hasHotspotChild && ![PAGE, SECTION_COLUMN].includes(parentType);

      const invalidReparent =
      parentWidget ||
      denyHotspotReparent ||
      (breakPointType === 'mobile' && parentType !== HOTSPOT) ||
      (parentType === HOTSPOT && childrenHasHotspot);

      return !invalidReparent;
    }
  }
}

function getCarouselBackground(childrenWidgets, currentSlide) {
  if (!currentSlide) {
    var defaultSlide = _.find(childrenWidgets, { order: 1 });
    return _.get(defaultSlide, 'properties.desktop.background')
  }

  const currentCarousel = _.find(childrenWidgets, { uid: currentSlide });
  return _.get(currentCarousel, 'properties.desktop.background')
}

function getPaginationStyles(properties, isActive, lastPagination) {
  var dotIconstyles = {
  };

  if (!properties && !_.get(properties, 'flag')) {
    return dotIconstyles;
  }

  //font-color
  const defaultcolor = _.get(properties, `defaultColor`, null);
  const selectedcolor = _.get(properties, `selectedColor`, null);

  const color = getColorStyles(isActive ? selectedcolor : defaultcolor);
  dotIconstyles = {
    ...dotIconstyles,
    ...color
  }

  //font-size
  const fontSizeString = _.get(properties, 'size', 8);
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }

  dotIconstyles['fontSize'] = fontSize;

  //marginRight
  const spaceBetween = _.get(properties, 'cornerRadius', 8);
  var marginRight = 'inherit'
  if (spaceBetween && !lastPagination) {
    marginRight = parseInt(spaceBetween) + 'px';
  }

  dotIconstyles['marginRight'] = marginRight;

  return dotIconstyles;
}

function getArrowStyles(properties) {
  var arrowIconstyles = {};

  if (!properties) {
    return arrowIconstyles;
  }

  const deviceProperties = properties;
  const defaultStyles = _.get(deviceProperties, `regular`, {});

  //font-color
  const colorRgb = _.get(defaultStyles, `color`, null);
  const color = getColorStyles(colorRgb);
  arrowIconstyles = {
    ...arrowIconstyles,
    ...color
  }

  //font-size
  const fontSizeString = _.get(deviceProperties, 'size', null);
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }

  arrowIconstyles['fontSize'] = fontSize;

  return arrowIconstyles;
}

function getNavigationButtonStyles(direction, properties, active) {
  var styles = {};

  if (!properties) {
    return styles;
  }

  //background
  const backgroundRgb = _.get(properties, `${active}.backgroundColor`, null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = `rgba(${backgroundRgb.r}, ${backgroundRgb.g}, ${backgroundRgb.b}, ${backgroundRgb.a})`;
  }

  styles['backgroundColor'] = background;

  //border
  const border = _.get(properties, 'backgroundCornerRadius', {});
  const borderStyle = getBorderStyles(border);
  styles = {
    ...styles,
    ...borderStyle
  }

  //offset
  const offset = _.get(properties, 'offset');

  if (direction == 'left') {
    styles = {
      ...styles,
      left: parseInt(offset) + 'px'
    }
  }

  if (direction == 'right') {
    styles = {
      ...styles,
      right: parseInt(offset) + 'px'
    }
  }

  return styles;
}

function getStyles(widgetProps, breakpoint, container){
  const stretched = _.get(widgetProps, 'properties.desktop.stretched', false);
  const freeSize = _.get(widgetProps, 'properties.desktop.free', false);
  const margin = _.get(widgetProps, 'properties.desktop.margin', 0);
  const padding = _.get(widgetProps, `properties.${breakpoint}.padding`, 0);

  const containerProps = _.get(container, `properties.${breakpoint}.container`);

  const visibleWidth = _.get(containerProps, `minWidth`);
  const alignment = _.get(containerProps, `alignment`) || 'center';

  var multiplier = 0;
  if (alignment == 'center') {
    multiplier = 0.5;
  } else if (alignment == 'right') {
    multiplier = 1;
  }

  var widgetStyles = {
    marginLeft: `calc((100% - ${visibleWidth}px) * ${multiplier})`,
    paddingTop: `${padding}px`,
    paddingBottom: `${padding}px`
  }

  if (breakpoint === 'desktop') {
    widgetStyles = {
      ...widgetStyles,
      paddingLeft: `${padding}px`,
      width: '100%',
      paddingRight: `${padding}px`
    }

    if (stretched && !freeSize) {
      widgetStyles = {
        ...widgetStyles,
        width: `calc(var(--editor-width) - 2 * ${margin}px)`,
        left: `calc((100% - (var(--editor-width) - 2 * ${margin}px))/2)`
      }
    }
  }

  if (breakpoint === 'mobile') {
    widgetStyles = {
      ...widgetStyles,
      width: '100%'
    }
  }

  return widgetStyles;
}

export function getColorStyles(value) {
  if (!value) {
    return null;
  }

  const colorRgb = value;

  var color = 'inherit';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  var styles = {
    color: color
  };

  return styles;
}

export function getBorderStyles(value) {
  if (!value) {
    return null;
  }

  var styles = {
    borderRadius: parseInt(value) + 'px'
  };

  return styles;
}

const Handle = React.forwardRef((props, ref) => {
  return (
    <div className={cx(styles.handle, 'item-drag-icon')} {...props} ref={ref}>
      <div className={styles.line}>
        {_.times(2).map((index) => {
          return <span key={index} />;
        })}
      </div>
      <div className={styles.line}>
        {_.times(2).map((index) => {
          return <span key={index} />;
        })}
      </div>
      <div className={styles.line}>
        {_.times(2).map((index) => {
          return <span key={index} />;
        })}
      </div>
    </div>
  );
});

export { CarouselWidget };